const PHASE_LABELS = new Map<string, string>([
  ['submitted', '提交'],
  ['queued', '排队'],
  ['worker_accepted', 'Worker 接受'],
  ['turn_started', 'Turn 开始'],
  ['completed', '结束'],
]);

export function computerDiagnosticPhaseLabel(phase: string): string {
  return PHASE_LABELS.get(phase) ?? phase;
}
